import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagTitle: {
		defaultMessage: 'Error saving gadget name',
		id: 'dashboard-edit.gadget-editable.utils.error-flag-title',
		description: 'Title of the flag shown when the gadget title was not successfully saved',
	},
	errorFlagDescription: {
		defaultMessage: 'Refresh the page and try again',
		id: 'dashboard-edit.gadget-editable.utils.error-flag-description',
		description: 'Description of the flag shown when the gadget title was not successfully saved',
	},
	errorFlagAction: {
		defaultMessage: 'Refresh',
		id: 'dashboard-edit.gadget-editable.utils.error-flag-action',
		description: 'Button of the flag shown when the gadget title was not successfully saved',
	},
});
